var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaccumeCleanerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 25.47A1.5 1.5 0 1 0 6.5 27 1.5 1.5 0 0 0 5 25.47Zm0 2a.5.5 0 0 1-.5-.5.5.5 0 0 1 1 0 .5.5 0 0 1-.5.5Zm25.35 1.14-2-2a.5.5 0 0 0-.35-.14h-2.73L19.84 5.14A5 5 0 0 0 15 1.47h-4.91A2.59 2.59 0 0 0 7.5 4.05v2.8a1.62 1.62 0 0 0 1.61 1.62h2.8a1.59 1.59 0 0 1 1.59 1.58v3.83l-.2-.22a7.41 7.41 0 0 0-5.54-2.19A4.57 4.57 0 0 0 3.5 16v7.79a3.49 3.49 0 1 0 3.94 5.65h5.06V30a.5.5 0 0 0 1 0v-.5H15a.5.5 0 0 0 .5-.5V19a7.48 7.48 0 0 0-1-3.72v-5.2a2.59 2.59 0 0 0-2.59-2.58h-2.8a.62.62 0 0 1-.61-.62V4.05a1.59 1.59 0 0 1 1.59-1.58H15a4 4 0 0 1 3.88 2.93l5.36 21.07h-.74a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5H30a.51.51 0 0 0 .46-.31.49.49 0 0 0-.11-.55ZM5 29.47A2.5 2.5 0 1 1 7.5 27 2.51 2.51 0 0 1 5 29.47ZM14.5 19v1.46h-3.51a.5.5 0 0 0 0 1h3.49v1h-3.51a.5.5 0 0 0 0 1h3.49v1h-3.51a.5.5 0 0 0 0 1h3.49v1h-3.51a.5.5 0 0 0 0 1h3.49v1H8.15a3.48 3.48 0 0 0-3.15-5 2.73 2.73 0 0 0-.5.05V16a3.56 3.56 0 0 1 3.29-3.56 6.39 6.39 0 0 1 4.81 1.9A6.49 6.49 0 0 1 14.5 19Zm9.5 9.5v-1h3.79l1 1Zm-15-14a2.5 2.5 0 1 0 2.5 2.5A2.5 2.5 0 0 0 9 14.47Zm0 4a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 9 18.47Z",
    fill: "current",
    className: "color000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccumeCleanerIcon);
export default __webpack_public_path__ + "static/media/vaccume-cleaner-icon.e3343ed063fae261c87150cb4aa91d7b.svg";
export { ForwardRef as ReactComponent };